<template>
  <form v-if="items.length > 0" method="post" action="/personal/cart/" name="basket_form">
    <div class="cart_wrap">
      <div class="wrapper">
        <div class="row">
          <div class="large-12 medium-12 small-12 columns">
            <div class="basket-notice" v-if="isQuantityOverflowed">
              <div class="content">
                {{ localize.KZ_BASKET_QUANTITY_OVERFLOW_MESSAGE }}
              </div>
            </div>
            <div class="basket-notice" v-if="isSumOverflowed">
              <div class="content">
                {{ localize.KZ_BASKET_SUM_OVERFLOW_MESSAGE.replace('#MAX_SUM#', this.maxSum.toLocaleString("ru-RU")) }}
              </div>
            </div>
            <div class="table-wrap">
              <div class="cart_list cart-table pos-r">
                <div class="tr">
                  <div class="th"></div>
                  <div class="th cell_name">{{ localize.KZ_BASKET_ITEM_NAME }}</div>
                  <div class="th cell_sale">{{ localize.KZ_BASKET_ITEM_DISCOUNT }}</div>
                  <div class="th cell_price">{{ localize.KZ_BASKET_ITEM_PRICE }}</div>
                  <div class="th cell_qty">{{ localize.KZ_BASKET_ITEM_QUANTITY }}</div>
                  <div class="th custom"></div>
                </div>
                <basket-item
                    v-for="basketItem in items"
                    v-bind="basketItem"
                    @input="updateItemQuantityHandler({ id: basketItem.id, quantity: $event })"
                    :previewImage="itemPreviewImage(basketItem.id)"
                    :previewImage2x="itemPreviewImage2x(basketItem.id)"
                    :price="basketItem.price"
                    :oldPrice="basketItem.oldPrice"
                ></basket-item>

                <div class="dr-modal dr-modal-sm-biggemore dr-modal__default modal-approve-delete-product"
                     id="id-modal-approve-delete-product"
                     data-modal="modal-approve-delete-product">
                  <div class="dr-modal-wrapper">
                    <div class="dr-modal__content bg-light">
                      <div class="dr-modal__header">
                        <div class="dr-modal__title">
                          <p class="dr-h3 ff-secondary">Подтверждение удаления</p>
                        </div>
                      </div>
                      <div class="dr-modal__body">
                        <div class="dr-modal__body-content">
                          <p class="dr-text__normal mb-25">Вы действительно хотите удалить этот товар?</p>
                          <div class="dr-form-group__flex justify-content-center">
                            <button class="dr-btn dr-btn__small dr-btn-inline dr-btn-brown__light dr-btn__outline">Удалить</button>
                            <button class="dr-btn dr-btn__small dr-btn-inline dr-btn-brown__light" onclick="drModalHide($(this))">Отмена</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="dr-modal__overlay"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="card_wrap cart_paid_block">
      <div class="wrapper">
        <div class="card_wrap cart_paid_block_order">
          <div class="wrapper">
            <div class="row">
              <div class="large-8 medium-7 small-12 columns">
                <a href="/e-shop/" class="back_to_list_news back_to_catalog">{{ localize.KZ_BASKET_BACK_TO_SHOPPING }}</a>
              </div>
              <div class="large-4 medium-5 small-12 columns">
                <div class="row" v-if="totals.discountSum > 0">
                  <div class="_main_sum_">
                    <span class="label_form label_main_sum">{{ localize.KZ_BASKET_SUMMARY_BASE }}</span>
                    <span id="allSum_FORMATED" class="discount_value discount_value_main" v-html="totals.basePriceFormatted"></span>
                  </div>
                </div>
                <div class="row" v-if="totals.discountSum > 0">
                  <div class="_main_sum_">
                    <span class="label_form label_main_sum">{{ localize.KZ_BASKET_SUMMARY_DISCOUNT }}</span>

                    <span id="allSum_FORMATED" class="discount_value discount_value_main">
                      <span v-html="totals.discountSumFormatted"></span>
                      (<span v-html="totals.discountPercentFormatted"></span>)
                    </span>
                  </div>
                </div>
                <div class="row">
                  <div class="_main_sum_">
                    <span class="label_form label_main_sum">{{ localize.KZ_BASKET_SUMMARY }}</span>
                    <span id="allSum_FORMATED" class="discount_value discount_value_main" v-html="totals.sumFormatted"></span>
                  </div>
                </div>
                <div class="row">
                  <div class="cart_send_paid_block ovh">
                    <a
                        :href="!isSumOverflowed ? params.PATH_TO_ORDER : 'javascript:;'"
                        :class="['order_button', 'pixel-order-btn', 'checkout-fixed-button', {'disabled' : isSumOverflowed}]"
                    >{{ localize.KZ_BASKET_PROCESS_ORDER }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cart-mobile__total-container js-cart-mobile-total">
      <div class="cart-mobile__total-wrap">
        <div class="cart-mobile__total-text">{{ localize.KZ_BASKET_SUMMARY }}</div>
        <div id="allSum_FORMATED" class="cart-mobile__total-value" v-html="totals.sumFormatted"></div>
      </div>
      <div class="cart-mobile__button-wrap">
        <a
            :href="!isSumOverflowed ? params.PATH_TO_ORDER : 'javascript:;'"
            :class="['cart-mobile__button', {'disabled' : isSumOverflowed}]"
        >{{ localize.KZ_BASKET_PROCESS_ORDER }}</a>
      </div>
    </div>
    <div class="cart-mobile__total-placeholder js-cart-mobile-total-placeholder"></div>
  </form>
  <div v-else id="basket_items_list">
    <div id="basket_items_list">
      <table cellspacing="0" cellpadding="0" width="100%" border="0">
        <tbody>
        <tr>
          <td class="img_wrapp">
          </td>
          <td>
            <div class="text">
              <div class="title text-center dr-text__normal c-black">{{ localize.KZ_BASKET_EMPTY_BASKET_TITLE }}</div>
              <div class="title"></div>
              <div class="text-center mt-15">
                <a href="/e-shop/odezhda" class="dr-btn dr-btn__brown dr-btn__outline">{{ localize.KZ_BASKET_EMPTY_BASKET_CATALOG_LINK }}</a>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
  import BasketItem from './basket-item.vue';
  import QuantityOverflow from "./quantity-overflow.vue";
  import { Vuex } from 'ui.vue.vuex';
  import { tmrOpenBasket } from 'kanzler.my-target';

  export default {
    props: {
      result: {
        required: true,
        type: Object,
      },
      params: {
        required: true,
        type: Object,
      },
      template: {
        required: true,
        type: String,
      },
      signedParamsString: {
        required: true,
        type: String,
      },
      siteId: {
        required: true,
        type: String,
      },
      siteTemplateId: {
        required: true,
        type: String,
      },
      overflowLimit: {
        required: true,
        type: Number,
      },
    },
    data: () => ({
      quantityOverflowTimer: null,
    }),
    components: {
      'quantity-overflow': QuantityOverflow,
      'basket-item': BasketItem,
    },
    computed: {
      ...Vuex.mapGetters(['totals', 'items', 'maxSum', 'itemPreviewImage', 'itemPreviewImage2x', 'isQuantityOverflowed', 'isSumOverflowed']),
      localize() {
        return BX.Vue.getFilteredPhrases('KZ_BASKET_');
      },
    },
    methods: {
      ...Vuex.mapActions(['updateItemQuantity']),
      updateItemQuantityHandler(id, quantity) {
        this.updateItemQuantity(id, quantity);
      },
    },
    mounted() {
      const firstTimeRefreshed = this.$store.watch(
        (_, { items }) => items,
        (items) => {
          firstTimeRefreshed();

          tmrOpenBasket(items).then((basketOpenImpression) => {
            window._tmr.push(basketOpenImpression);
          })

        });
    }
  };

  document.addEventListener('scroll', function () {
    if(window.innerWidth > 768) {
      return;
    }

    let total = document.querySelector('.js-cart-mobile-total');
    let placeholder = document.querySelector('.js-cart-mobile-total-placeholder');
    let box = placeholder.getBoundingClientRect();

    if(box.top - 61 < 0 || box.bottom > window.innerHeight) {
      total.classList.add('cart-mobile__total-container--fixed');
      return;
    }

    total.classList.remove('cart-mobile__total-container--fixed');
  });
</script>
<style>

  .basket-notice {
    padding: 20px 0 20px 2%;
  }

  .basket-notice .content {
    padding: 15px 15px 15px 48px;
    background: #FCF8F6;
    position: relative;
  }
  .basket-notice .content:before {
    content: '!';
    display: block;
    position: absolute;
    top: 12px;
    left: 15px;
    border: 1px solid red;
    border-radius: 40%;
    color: red;
    width: 24px;
    height: 24px;
    line-height: 23px;
    font-weight: bold;
    vertical-align: middle;
    text-align: center;
    font-size: 20px;
  }

  .cart-mobile__total-placeholder {
    display: none;
    height: 0;
  }

  .cart-mobile__total-container {
    background: #FCF8F6;
    width: 100%;
    display: none;
    justify-content: space-between;
    align-items: center;
    z-index: 10000000000;
  }

  .cart-mobile__total-container--fixed {
    position: fixed;
    bottom: 0;
  }

  .cart-mobile__total-container--fixed + .cart-mobile__total-placeholder {
    height: 60px;
  }

  .cart-mobile__total-wrap {
   margin-left: 14px
  }


  .cart-mobile__total-text {
    font: normal 500 12px 'Montserrat';
    color: #84807D;
    margin-bottom:5px;
  }

  .cart-mobile__total-value {
    font: normal 500 14px 'Montserrat';
    text-transform: uppercase;
    color: #2C180B;
  }

  .cart-mobile__button-wrap {
    margin-top: 10px;
    margin-bottom: 10px;
    margin-right: 14px;
  }

  .cart-mobile__button {
    display: block;
    background: #E13A16;
    border-radius: 5px;
    padding: 14px 32px;
    color: #FFFFFF;
    font: normal 600 12px 'Montserrat';
    text-transform: uppercase;
  }

  .order_button.disabled {
    opacity: 0.6;
    cursor: default;
  }
  .order_button.disabled:hover {
    background: #9e7c61;
  }
  .cart-mobile__button.disabled {
    opacity: 0.6;
    cursor: default;
  }
  .cart-mobile__button:hover {
    color: #fff;
  }

@media (max-width: 768px) {
  .cart_paid_block {
   display: none;
  }

  .cart-mobile__total-container {
    display: flex;
  }

  .cart-mobile__total-placeholder {
    display: block;
  }
}
</style>